
import './style.scss';
import { useState, useCallback, useRef } from 'react';
import { Grid, Typography } from '@mui/material';
import DefaultConstants from '../../data/Constants';
import TextField from '../../components/TextField';
import Button from '../../components/Button';
import LanguagesSelector from '../../components/Languages/LanguagesSelector';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { useUserContext } from '../../contexts/UserContext';
import AuthService from '../../services/AuthService';
import FormHelper from '../../helpers/FormHelper';
import { useEnvironmentContext } from '../../contexts/EnvironmentContext';
import DateTimeHelper from '../../helpers/DateTimeHelper';


const Login = () => {
    const { translate } = useLanguageContext();
    const { environment } = useEnvironmentContext();
    const { handleLogin } = useUserContext();

    const loginRef = useRef<HTMLInputElement | null>(null);
    const [login, setLogin] = useState<string>('');

    const [password, setPassword] = useState<string>('');


    const handleRecoverPassword = useCallback(() => {
        if (login.trim().length > 0) {
            const formData = FormHelper.Create(undefined);
            formData.append('login', login);

            AuthService.RecoverPassword(formData);
        } else if (loginRef.current) {
            loginRef.current.focus();
        }

        // eslint-disable-next-line
    }, [translate, loginRef, login]);


    const handleSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const formData = FormHelper.Create(event);
        handleLogin(formData);
        // eslint-disable-next-line
    }, []);
    

    return (
        <Grid container component='form' onSubmit={e => handleSubmit(e)} className='container-login'>
            <Grid item lg={4} md={6} sm={8} xs={12} className='grid-login'>
                <Grid item xs={12} className='grid-languages'>
                    <LanguagesSelector size='small' />
                </Grid>

                <Grid item xs={12} className='grid-logo'>
                    <img src={environment.partnerPms.images.logoHorizontal} alt={environment.partnerPms.description} className='image-icon' />
                </Grid>

                <Grid item xs={12} className='grid-fields'>
                    <Grid item xs={12}>
                        <Typography component='h1' variant='subtitle2' className='textalign-center text-description'>
                            {translate('_loginScreenDescription')}
                        </Typography>

                        <Typography component='h1' variant='subtitle2' className='text-color-1 fontweight-600 textalign-center'>
                            {environment.partnerPms.systemName}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} marginTop={3}>
                        <TextField 
                            label={translate('user')}
                            name='login' 
                            value={login}
                            onChange={(e) => setLogin(e.target.value)}
                            inputRef={loginRef}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField 
                            label={translate('password')}
                            name='password'
                            type="password" 
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} className='textalign-right'>
                        <Typography component='span' variant='subtitle2' className='text-recover-password' onClick={handleRecoverPassword}>
                            {translate('forgotPassword')}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item xs={12} className='grid-buttons'>
                    <Button
                        type='submit'
                        disableElevation={true}
                        fullWidth={true}
                        className='background-primary'
                        label={translate('logon').toUpperCase()}
                    />
                </Grid>

                <Grid item xs={12} className='grid-version'>
                    <Typography component='h6' variant='subtitle2' className='fontsize-10 text-color-2'>
                        {translate('developedBy')}
                        {' '}
                        <Typography 
                            component='span' 
                            onClick={() => window.open(DefaultConstants.developer.website)} 
                            variant='subtitle2' 
                            className='fontweight-600 fontsize-10 cursor-pointer'
                        > 
                            {DefaultConstants.developer.name} 
                        </Typography>
                    </Typography>

                    <Grid container className='grid-version-copyright'>
                        <Grid item>
                            <Typography component='h6' variant='subtitle2' className='fontsize-10 text-color-2'>
                                {translate('copyright').replace('{date}', DateTimeHelper.Now('YYYY'))}
                            </Typography>
                        </Grid>

                        <Grid item>
                            <Typography component='h6' variant='subtitle2' className='fontsize-10 text-color-2 textalign-right'>
                                v{environment.version}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}


export default Login;